import classNames from 'classnames';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    green: {
        backgroundColor: '#E9FBF2',
        border: '1px solid #1B9757',
        color: '#1B9757'
    },
    yellow: {
        backgroundColor: '#FEF3E7',
        border: '1px solid #7A4406',
        color: '#7A4406'
    },
    memberHeading: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    title: {
        width: '100%',
        color: '#7A4406',
        fontSize: '24px',
        fontWeight: 700,
        textAlign: 'center'
    },
    titleGreen: {
        color: '#1B9757'
    },
    photoContainer: {
        marginBottom: '20px',
        position: 'relative',
        height: '100px',
        width: '100px',
        '& img': {
            objectFit: 'cover',
            borderRadius: '50%',
            height: '100%',
            width: '100%'
        }
    },
    photoBorderGreen: {
        border: '2px solid #1B9757',
        borderRadius: '50%'
    },
    photoBorderYellow: {
        border: '2px solid #7A4406',
        borderRadius: '50%'
    },
    photoIconContainer: {
        position: 'absolute',
        bottom: '0px',
        right: '-4px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '24px',
        width: '24px',
        '& i': {
            fontSize: '16px'
        }
    },
    subtextDiv: {
        padding: '12px 24px 0 24px', 
        textAlign: 'center',
        '& span': {
            color: '#1F2152',
            fontWeight: 300,
            fontSize: '16px',
            lineHeight: '1.5',
            display: 'block'
        }
    },
}));

const MemberStatus: React.FC<{
    photo?: string;
    icon: string;
    title: string;
    subtext: string;
    colorType: 'green' | 'yellow';
}> = ({ photo, icon, title, subtext, colorType }) => {
    const classes = useStyles(); 

    return (
        <div className={classes.memberHeading}>
            <>
                <div
                    className={classNames(
                        classes.photoContainer,
                        colorType === 'green' ? classes.photoBorderGreen : classes.photoBorderYellow
                    )}
                >
                    {photo && <img src={photo} alt="member" />}
                    <div
                        className={classNames(
                            classes.photoIconContainer,
                            colorType === 'green' ? classes.green : classes.yellow
                        )}
                    >
                        <i className={icon} />
                    </div>
                </div>
                <span className={classNames(classes.title, colorType === 'green' && classes.titleGreen)}>
                    {title}
                </span>
                <div className={classes.subtextDiv}>
                    <span>
                        {subtext}
                    </span>
                </div>
            </>
        </div>
    );
};

export default MemberStatus;
